export const app = {
  data () {
    return {
    }
  },
  methods: {
    checkPowerSupply (ethernet, sfp) {
      let cluster = this[this.page]
      cluster.powerSupply.ethernet = ethernet
      cluster.powerSupply.sfp = sfp

      this.$store.commit('app/UPDATED_CLUSTER', [this.page, cluster])
      this.obliczenia_sprzetowe()
    },
    checkOutput24 (device, ethernet, maxCurrent, countU) {
      let cluster = this[this.page]
      cluster.output24.selected = device
      cluster.output24.ethernet = Number(ethernet)
      cluster.output24.maxCurrent = Number(maxCurrent)
      cluster.output24.countU = Number(countU)

      // console.log(this.clusterOne)
      // console.log(cluster)
      // console.log('this.page: ', this.page)
      // let clusterOld = []
      // clusterOld = (this.page === 'cluster1') ? this.clusterOne : []
      // // if (Number(this.outputs.szafa.attributes.wysokosc) === 50) {
      // if (clusterOld.output24.selected !== device) {
      //   console.log('różne')
      //   console.log(countU, ' / ', this.outputs.szafa_wolne_miejsce.value)
      // } else {
      //   console.log('to samo')
      // }
      // }
      // console.log(this.outputs.szafa.attributes.wysokosc)
      // console.log(cluster)
      // console.log(cluster.output24.selected)
      this.$store.commit('app/UPDATED_CLUSTER', [this.page, cluster])
      // console.log('checkOutput24')
      this.obliczenia_sprzetowe()
    },
    checkOutput48one (device, ethernet, loudspeaker, sfp, poe, currentMode, currentAlarm, countU) {
      let cluster = this[this.page]
      this.clearDevice(cluster, 'one')
      cluster.output48one.selected = device
      cluster.output48one.ethernet = Number(ethernet)
      cluster.output48one.loudspeaker = Number(loudspeaker)
      cluster.output48one.sfp = Number(sfp)
      cluster.output48one.poe = Number(poe)
      cluster.output48one.currentMode = Number(currentMode)
      cluster.output48one.currentAlarm = Number(currentAlarm)
      cluster.output48one.countU = Number(countU)

      this.$store.commit('app/UPDATED_CLUSTER', [this.page, cluster])
      this.obliczenia_sprzetowe()
    },
    checkOutput48two (device, ethernet, loudspeaker, sfp, poe, currentMode, currentAlarm, countU) {
      let cluster = this[this.page]
      this.clearDevice(cluster, 'two')
      cluster.output48two.selected = device
      cluster.output48two.ethernet = Number(ethernet)
      cluster.output48two.loudspeaker = Number(loudspeaker)
      cluster.output48two.sfp = Number(sfp)
      cluster.output48two.poe = Number(poe)
      cluster.output48two.currentMode = Number(currentMode)
      cluster.output48two.currentAlarm = Number(currentAlarm)
      cluster.output48two.countU = Number(countU)

      this.$store.commit('app/UPDATED_CLUSTER', [this.page, cluster])
      this.obliczenia_sprzetowe()
    },
    checkOutput48three (device, ethernet, loudspeaker, sfp, poe, currentMode, currentAlarm, countU) {
      let cluster = this[this.page]
      this.clearDevice(cluster, 'three')
      cluster.output48three.selected = device
      cluster.output48three.ethernet = Number(ethernet)
      cluster.output48three.loudspeaker = Number(loudspeaker)
      cluster.output48three.sfp = Number(sfp)
      cluster.output48three.poe = Number(poe)
      cluster.output48three.currentMode = Number(currentMode)
      cluster.output48three.currentAlarm = Number(currentAlarm)
      cluster.output48three.countU = Number(countU)

      this.$store.commit('app/UPDATED_CLUSTER', [this.page, cluster])
      this.obliczenia_sprzetowe()
    },
    checkCallStation (desktop, wall, ext, poe, cst) {
      let cluster = this[this.page]
      // let cluster = JSON.parse(JSON.stringify(this.clusterOne))
      cluster.callStation.csDesktop = desktop
      cluster.callStation.csWall = wall
      cluster.callStation.csExt = ext
      cluster.callStation.poePorts = poe
      cluster.callStation.cstEmergency = cst

      this.$store.commit('app/UPDATED_CLUSTER', [this.page, cluster])
      this.obliczenia_sprzetowe()
      // this.$store.commit('app/UPDATED_CLUSTER', ['cluster1', cluster])
      // this.obliczenia_sprzetowe()
    },
    clearDevice (cluster, num) {
      let str = 'output48' + num
      Object.keys(cluster[str]).forEach(items => {
        if (items !== 'selected') {
          cluster[str][items] = 0
        }
      })
    },
    changeValueOutputs (name, type, val) {
      this.$store.commit('app/UPDATED_OUTPUTS', {
        'name': name,
        'type': type,
        'val': val
      }, { root: false })
    },
    changeValueInputs (name, type, val) {
      // console.log(name, type, val)
      this.$store.commit('app/UPDATED_INPUTS', {
        'name': name,
        'type': type,
        'val': val
      }, { root: false })
    },
    changeInputs (event) {
      if (this.inputData[event].value !== undefined) {
        this.changeValueInputs(event, 'value', this.inputData[event].value)
        this.$store.commit('app/UPDATED_SELECTED_INPUT', event)
      }
      // this[event](this.inputData[event])
      this.changeOther(event, this.inputData[event].value)
    },
    // changeConfig (event) {
    //   if (this.inputData[event] !== undefined) {
    //     console.log(this.inputData[event])
    //     this.$store.commit('app/UPDATED_SELECTED_CONFIG', [event, this.inputData[event]])
    //   }
    //   // this[event](this.inputData[event])
    //   // this.changeOther(event, this.inputData[event].value)
    // },
    changeValuePrice (name, val) {
      this.$store.commit('app/UPDATED_PRICE', {
        'name': name,
        'val': val
      }, { root: false })
    },
    changeValueWeight (name, val) {
      this.$store.commit('app/UPDATED_WEIGHT', {
        'name': name,
        'val': val
      }, { root: false })
    },
    changeOther (labelName, value) {
      // console.log(labelName, value)
      if (labelName === 'czas_podtrzymania') {
        // this.changeValueInputs('dodatkowe_u', 'value', value)
        this.obliczenia_sprzetowe()
      }
      if (labelName === 'dodatkowe_u') {
        if (value > this.inputs[labelName].max) {
          this.changeValueInputs('dodatkowe_u', 'value', this.inputs[labelName].max)
        } else {
          this.changeValueInputs('dodatkowe_u', 'value', value)
        }
        // this.changeValueInputs('dodatkowe_u', 'value', value)
        this.obliczenia_sprzetowe()
      }
      if (labelName === 'glebokosc_szafy') {
        this.changeValueInputs('glebokosc_szafy', 'active', true)
        this.changeValueInputs('glebokosc_szafy', 'value', Number(this.inputData.glebokosc_szafy.value))
        // console.log('zajmowaneOtw: ', this.inputData.glebokosc_szafy.value)
      }
      if (labelName === 'przylacze_zasilania') {
        this.changeValueInputs('przylacze_zasilania', 'active', true)
        this.changeValueInputs('przylacze_zasilania', 'value', Number(this.inputData.przylacze_zasilania.value))
        this.obliczenia_sprzetowe()
      }
      if (labelName === 'kolka') {
        this.changeValueInputs(labelName, 'value', value)
        var device = this.ListaPulsar.filter(item => item.kod === 'MRAKK1')

        if (value === 1) {
          this.changeValuePrice('kolka', Number(device[0].attributes.cena))
          this.changeValueWeight('kolka', Number(device[0].attributes.waga))
          this.$store.commit('products/SET_LIST_SELECTED', {'key': 'kolka', 'value': device[0]})
        } else {
          this.changeValuePrice('kolka', 0)
          this.changeValueWeight('kolka', 0)
          this.$store.commit('products/SET_LIST_SELECTED', {'key': 'kolka', 'value': []})
        }
      }
      if (labelName === 'obudowa_plytki') {
        this.changeValueInputs(labelName, 'value', value)
        var deviceAWO = this.ListaPulsar.filter(item => item.kod === 'AWO506')
        if (deviceAWO && deviceAWO[0]) {
          this.changeValuePrice('obudowa_plytki', (Number(value) * Number(deviceAWO[0].attributes.cena)))
          this.changeValueWeight('obudowa_plytki', (Number(value) * Number(deviceAWO[0].attributes.waga)))
          if (Number(value) > 0) {
            this.$store.commit('products/SET_LIST_SELECTED', {'key': 'obudowa_plytki', 'value': deviceAWO[0]})
          } else {
            this.$store.commit('products/SET_LIST_SELECTED', {'key': 'obudowa_plytki', 'value': []})
          }
        } else {
          this.$store.commit('products/SET_LIST_SELECTED', {'key': 'obudowa_plytki', 'value': []})
        }
      }
      if (labelName === 'panel_wentylacyjny') {
        this.changeValueInputs(labelName, 'value', value)
        if (value === 1) {
          // if (this.inputs.glebokosc_szafy.value === 600 || this.inputs.glebokosc_szafy.value === '600') {
          var cenaWentylator = 0
          var wagaWentylator = 0
          var deviceZaslepka = this.ListaPulsar.filter(item => item.kod === 'RAPZ1')
          var cenaZaslepka = deviceZaslepka[0].attributes.cena
          var wagaZaslepka = deviceZaslepka[0].attributes.waga
          this.$store.commit('products/SET_LIST_SELECTED', {'key': 'zaslepka', 'value': deviceZaslepka[0]})
          var device600 = this.ListaPulsar.filter(item => item.kod === 'RAWP600RZ')
          cenaWentylator = Number(device600[0].attributes.cena)
          wagaWentylator = Number(device600[0].attributes.waga)
          this.$store.commit('products/SET_LIST_SELECTED', {'key': 'panelW', 'value': device600[0]})
          this.changeValuePrice('panelW', (Number(cenaWentylator) + Number(cenaZaslepka)))
          this.changeValueWeight('panelW', (Number(wagaWentylator) + Number(wagaZaslepka)))

          // } else {
          //   var device800 = this.ListaPulsar.filter(item => item.kod === 'RAWP800RZ')
          //   cenaWentylator = Number(device800[0].attributes.cena)
          //   this.changeValuePrice('panelW', (Number(cenaWentylator) + Number(cenaZaslepka)))
          // }
        } else {
          this.changeValuePrice('panelW', 0)
          this.changeValueWeight('panelW', 0)
          this.$store.commit('products/SET_LIST_SELECTED', {'key': 'zaslepka', 'value': []})
          this.$store.commit('products/SET_LIST_SELECTED', {'key': 'panelW', 'value': []})
        }
        this.obliczenia_sprzetowe()
      }
      if (labelName === 'wariant3') { // mikrofon do 80
        this.changeValueInputs('wariant3_rozszerzenia', 'max', (2 * value))

        if (value === 0 || value === '0') {
          this.changeValueInputs('wariant3_rozszerzenia', 'value', 0)
        }
        var deviceObudowa = this.ListaPulsar.filter(item => item.kod === 'DSOS24VPU')
        if (deviceObudowa && deviceObudowa[0]) {
          this.changeValuePrice('obudowa_dsos24', (Number(value) * Number(deviceObudowa[0].attributes.cena)))
          this.changeValueWeight('obudowa_dsos24', (Number(value) * Number(deviceObudowa[0].attributes.waga)))
          if (Number(value) > 0) {
            this.$store.commit('products/SET_LIST_SELECTED', {'key': 'obudowa_dsos24', 'value': deviceObudowa[0]})
          } else {
            this.$store.commit('products/SET_LIST_SELECTED', {'key': 'obudowa_dsos24', 'value': []})
          }
        } else {
          this.$store.commit('products/SET_LIST_SELECTED', {'key': 'obudowa_dsos24', 'value': []})
        }
      }
      if (labelName === 'wariant2') { // mikrofon do 80
        this.changeValueInputs('wariant2_rozszerzenia', 'max', (2 * value))

        if (value === 0 || value === '0') {
          this.changeValueInputs('wariant2_rozszerzenia', 'value', 0)
        }
        var deviceZasilacz = this.ListaPulsar.filter(item => item.kod === 'DSOS24V-PRA')
        if (deviceZasilacz && deviceZasilacz[0]) {
          this.changeValuePrice('zasilacz_dsos24_pra', (Number(value) * Number(deviceZasilacz[0].attributes.cena)))
          this.changeValueWeight('zasilacz_dsos24_pra', (Number(value) * Number(deviceZasilacz[0].attributes.waga)))
          if (Number(value) > 0) {
            this.$store.commit('products/SET_LIST_SELECTED', {'key': 'zasilacz_dsos24_pra', 'value': deviceZasilacz[0]})
          } else {
            this.$store.commit('products/SET_LIST_SELECTED', {'key': 'zasilacz_dsos24_pra', 'value': []})
          }
        } else {
          this.$store.commit('products/SET_LIST_SELECTED', {'key': 'zasilacz_dsos24_pra', 'value': []})
        }
      }
      if (labelName === 'polka_mikrofon') {
        if (value === 1 || value === '1') {
          this.changeValuePrice('polka', Number(this.getPriceDevice('RAPW600', 'polka')))
          this.changeValueWeight('polka', Number(this.getWeightDevice('RAPW600')))
        } else {
          this.changeValuePrice('polka', 0)
          this.changeValueWeight('polka', 0)
          this.$store.commit('products/SET_LIST_SELECTED', {'key': 'polka', 'value': []})
        }
        this.obliczenia_sprzetowe()
      }
      this.configuration_keygen()
    },
    checkValue (item) {
      // console.log(item)
      if (item === 'rabat') {
        if (this.outputData.rabat.value > 99) {
          this.outputData.rabat.value = 99
        }
        if (this.outputData.rabat.value < 0) {
          this.outputData.rabat.value = 0
        }
        this.changeOutputs('rabat')
      }
      if (item === 'dodatkowe_u') {
        if ((50 * 3) - this.outputs.szafa_zajete_miejsce.value < 4) {
          this.inputData.dodatkowe_u.value -= 1
          this.inputData.dodatkowe_u.max = this.inputData.dodatkowe_u.value
          this.changeValueInputs('dodatkowe_u', 'max', this.inputData.dodatkowe_u.value)
        }
        if (this.inputData.dodatkowe_u.value < 0) {
          this.inputData.dodatkowe_u.value = 0
          this.inputData.dodatkowe_u.max = 50
          this.changeValueInputs('dodatkowe_u', 'max', 50)
        }
        this.changeInputs('dodatkowe_u')
      }
    },
    capitalizeFirstLetter (str) {
      return str.charAt(0).toUpperCase() + str.slice(1)
    },
    clearBattery (cluster) {
      this.changeValueOutputs(['akumulators', cluster], 'array', this.outputs.akumulators_buffor[cluster])
      this.changeValueOutputs(['akumulator_user', cluster], 'array', false)
      this.$store.commit('app/SET_RESULT_DEVICE', [this.prefix, Number(this.outputs.akumulators_buffor[cluster].pojemnosc)])
    },
    checkBatteriesShelfs (depth) {
      var glebokosc = depth // this.inputs.glebokosc_szafy.value
      var allBatteries = []
      Object.keys(this.outputs.akumulators).forEach(element => {
        if (this.outputs.akumulators[element]) {
          allBatteries.push(this.outputs.akumulators[element].pojemnosc)
        }
      })
      var shelfBatteriesSmall = []
      var shelfBatteriesBig = []
      var perChunkSmall = 0 // items per chunk
      var perChunkBig = 0 // items per chunk
      var resultSmall = []
      var resultBig = []
      var allShelfs = []

      if (glebokosc === 600 || glebokosc === '600') {
        // szafa 600
        allBatteries.forEach(element => {
          if (Number(element) === 200 || Number(element) === 230) {
            shelfBatteriesBig.push(element)
          } else {
            shelfBatteriesSmall.push(element)
          }
        })

        perChunkSmall = 2 // items per chunk
        resultSmall = shelfBatteriesSmall.reduce((resultArray, item, index) => {
          const chunkIndex = Math.floor(index / perChunkSmall)
          if (!resultArray[chunkIndex]) {
            resultArray[chunkIndex] = [] // start a new chunk
          }
          resultArray[chunkIndex].push(item)
          return resultArray
        }, [])

        perChunkBig = 1 // items per chunk
        resultBig = shelfBatteriesBig.reduce((resultArray, item, index) => {
          const chunkIndex = Math.floor(index / perChunkBig)
          if (!resultArray[chunkIndex]) {
            resultArray[chunkIndex] = [] // start a new chunk
          }
          resultArray[chunkIndex].push(item)
          return resultArray
        }, [])

        if (resultSmall.length > 0 && resultSmall.length > 0) {
          allShelfs = [...resultSmall, ...resultBig]
        } else {
          if (resultSmall.length > 0) {
            allShelfs = [...resultSmall]
          }
          if (resultBig.length > 0) {
            allShelfs = [...resultBig]
          }
        }
        // console.log(allShelfs)
        // console.log('allShelfs.length: ', allShelfs.length)
      } else {
        // szafa 800
        allBatteries.forEach(element => {
          if (Number(element) === 160 || Number(element) === 200 || Number(element) === 230) {
            shelfBatteriesBig.push(element)
          } else {
            shelfBatteriesSmall.push(element)
          }
        })

        perChunkSmall = 3 // items per chunk
        resultSmall = shelfBatteriesSmall.reduce((resultArray, item, index) => {
          const chunkIndex = Math.floor(index / perChunkSmall)
          if (!resultArray[chunkIndex]) {
            resultArray[chunkIndex] = [] // start a new chunk
          }
          resultArray[chunkIndex].push(item)
          return resultArray
        }, [])
        var resultSmallTemp = JSON.parse(JSON.stringify(resultSmall))

        var arrResztaSmall = []
        if (resultSmallTemp && resultSmallTemp[resultSmall.length - 1] && (resultSmallTemp[resultSmall.length - 1]).length < 2) {
          arrResztaSmall = JSON.parse(JSON.stringify(resultSmallTemp[resultSmallTemp.length - 1]))
          resultSmall.pop()
        }
        if (arrResztaSmall[0]) {
          shelfBatteriesBig.push(arrResztaSmall[0])
          shelfBatteriesBig.sort()
        }

        perChunkBig = 2 // items per chunk
        resultBig = shelfBatteriesBig.reduce((resultArray, item, index) => {
          const chunkIndex = Math.floor(index / perChunkBig)
          if (!resultArray[chunkIndex]) {
            resultArray[chunkIndex] = [] // start a new chunk
          }
          resultArray[chunkIndex].push(item)
          return resultArray
        }, [])

        if (resultSmall.length > 0 && resultSmall.length > 0) {
          allShelfs = [...resultSmall, ...resultBig]
        } else {
          if (resultSmall.length > 0) {
            allShelfs = [...resultSmall]
          }
          if (resultBig.length > 0) {
            allShelfs = [...resultBig]
          }
        }
        // console.log(allShelfs)
        // console.log('allShelfs.length: ', allShelfs.length)
      }
      return allShelfs.length
    },
    changeActiveBattery () {
      console.log('--- changeActiveBattery ---')
      this.activeBattery = !this.activeBattery
      this.$store.commit('app/SET_ACTIVE_BATTERY', [this.prefix, this.activeBattery])
      this.obliczenia_sprzetowe()
    },
    clear_clusters () {
      this.$store.commit('app/CLEAR_CLUSTERS')
      this.$store.commit('app/CLEAR_ADDRESS')
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/app.js